import { RawSkill } from "./skillsUtils";

export const RAW_SKILLS: RawSkill[] = [
  {
    name: "c",
    displayName: "C"
  },
  {
    name: "css",
    displayName: "CSS"
  },
  {
    name: "express",
    displayName: "Express.js"
  },
  {
    name: "git",
    displayName: "Git"
  },
  {
    name: "html",
    displayName: "HTML"
  },
  {
    name: "javascript",
    displayName: "JavaScript"
  },
  {
    name: "jest",
    displayName: "Jest"
  },
  {
    name: "nodejs",
    displayName: "Node.js"
  },
  {
    name: "react",
    displayName: "React.js"
  },
  {
    name: "scss",
    displayName: "SCSS"
  },
  {
    name: "storybook",
    displayName: "Storybook"
  },
  {
    name: "typescript",
    displayName: "TypeScript"
  }
];
